import getConfig from '../config/env';
import {getValue} from "./localStorage";

class Settings {
  constructor(config) {
    this.config = config;
  }

  getConfig() {
    return this.config;
  }

  getApiUrl(action) {
    return `${this.config.api}/${action}`;
  }
  getHEMSIntegrationApiUrl(action) {
    return `${this.config.HEMS_INTEGRATION}/${action}`;
  }
  enlightenCompanyUrl(companyId) {
    return `${this.config.enlighten_url}/account/companies/${companyId}/edit`;
  }

  digiCoreUrl(url) {
    return `${this.config.digital_core_url}/api/v1/${url}`;
  }

  permittingUrl(url) {
    return `${this.config.permitting_url}/api/v1/permit/${url}`;
  }

  enlightenMenuUrl(menu) {
    return `${this.config.enlighten_url}/${menu}`;
  }

  activationUrl() {
    return `${this.config.activation_url}`;
  }

  sgipUrl(menu) {
    return `${this.config.sgip_url}/${menu}`;
  }

  einCoreUrl(url) {
    return `${this.config.ein_core_url}/api/v1/${url}`;
  }

  getAdvanceAppliancesUrl() {
    return this.config.estimator_appliances_url;
  }

  permittingAdminUrl() {
    return `${this.config.permitting_url}/permitting_dashboard`;
  }

  sgipAdminUrl() {
    return `${this.config.sgip_url}/status_dashboard`;
  }

  solargraf(url) {
    return `${this.config.solargraf_url}/${url}`;
  }

  solargrafApiUrl(url) {
    return `${this.config.solargraf_api_url}/${url}`;
  }

  drsUiUrl(url) {
    return `${this.config.drs_ui_url}/${url}`;
  }

  getDrsUrl(url) {
    return `${this.config.drsUrl}/api/v1/${url}`;
  }

  getTrainingUrl(url) {
    return `${this.config.training_dashboard_url}/${url}`;
  }

  getBomUiUrl(url) {
    return `${this.config.bom_ui_url}/${url}`;
  }

  getModemReplacementUrl(token){
    return `${this.config.modem_replacement_url}?${token}`
  }

  getRmaDashboardUrl(token){
    const localeKey = getValue('locale_id') || '';
    return `${this.config.rma_dashboard_url}?token=${token}&lng=${localeKey}`
  }

  bomApiUrl(url) {
    return `${this.config.bom_api_url}/api/v1/${url}`;
  }

  getNotificationPreferenceUrl() {
    return this.config.notificationPreferenceUrl;
  }

  getFleetDashboardUrl() {
    return this.config.fleet_dashboard_url;
  }
  getTempGeneratorTokenUrl(endpoint) {
    return `${this.config.temp_generator_token_url}/${endpoint}`;
  }

  getTempQaGeneratorUrl(endpoint) {
    return `${this.config.temp_qa4_generator_url}/${endpoint}`;
  }

  get365ProntoUrl(){
    return `${this.config.enlighten_url}`;
  }
  
  getEnphaseUrl(url) {
    return `${this.config.enphase_url}/${url}`
  }
}

export default new Settings(getConfig());
